<template>
    <div>
        <div>
            <el-form inline size="small">
                <el-form-item label="商品分组">
                    <el-select v-model="searchParams.group_id" filterable clearable placeholder="全部"
                        @change="changeGroupId">
                        <el-option v-for="group in groupList" :key="group.id" :label="group.name"
                            :value="group.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品子分组">
                    <el-select v-model="searchParams.child_group_id" filterable clearable placeholder="全部">
                        <el-option v-for="group in child_groupList" :key="group.id" :label="group.name"
                            :value="group.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="3:4图状态">
                    <el-select v-model="searchParams.is_image_three_to_four" filterable clearable placeholder="全部">
                        <el-option v-for="item in imageWays" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="SKU替换状态">
                    <el-select v-model="searchParams.sku_status" clearable placeholder="全部">
                        <el-option v-for="item in skuWays" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
                    <el-button size="small" @click="refresh">重置</el-button>
                </el-form-item>
            </el-form>
            <div style="margin-bottom: 15px;">
                <el-button plain size="small" @click="handleCheck">生批量成3/4图</el-button>
            </div>
            <el-table :key="activeTab" v-loading="loading" :data="tableData" show-overflow-tooltip="false"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }" class="rc_table" row-key="id">
                <el-table-column type="selection" align="center" min-width="30" max-width="80"
                    :selectable="checkSelectable"></el-table-column>
                <el-table-column label="上新时间" prop="created_at_text" align="center" width="150">
                    <template slot-scope="scope">
                        {{ scope.row.created_at_text.split(' ')[0] }}
                    </template>
                </el-table-column>
                <el-table-column label="商品来源" prop="source_web" align="center" width="150">
                    <template slot-scope="scope">
                        <span class="source-tag" :class="{
                            tag2: scope.row.source_web === 2,
                            tag3: scope.row.source_web === 3,
                            tag4: scope.row.source_web === 4
                        }">
                            {{
                                scope.row.source_web === 2 ? '1688' :
                                    scope.row.source_web === 3 ? 'TB' :
                                        scope.row.source_web === 4 ? 'PDD' :
                                            '未知'
                            }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="分组" prop="group_name" align="center" width="200">
                    <template #default="{ row }">
                        <el-tooltip :content="formatGroupName(row)" placement="top" :open-delay="300"
                            popper-class="group-tip">
                            <span class="group-name-cell">{{ formatGroupName(row) }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="商品ID" prop="product_id" align="center"></el-table-column> -->
                <el-table-column label="商品信息" min-width="150" max-width="250">
                    <template slot-scope="scope">
                        <div class="goods_wrap">
                            <div class="img_box">
                                <img class="coverimg" :src="scope.row.main_image" alt="商品图" />
                            </div>
                            <div class="con_box">
                                <p class="info-item">
                                    <span class="color">{{ scope.row.product_id }}</span>
                                </p>
                                <p class="info-item">
                                    <span class="color">{{ scope.row.title }}</span>
                                </p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="3：4图状态" align="center" min-width="60" max-width="380">
                    <template #default="{ row }">
                        <div class="white-bg-status-wrap">
                            <!-- 状态文字标签 -->
                            <span class="status-tag" :class="{
                                tag1: row.is_image_three_to_four === 1,
                                tag2: row.is_image_three_to_four === 2,
                                tag3: row.is_image_three_to_four === 3 && !isImageExpire(row),
                                tagExpire: row.is_image_three_to_four === 3 && isImageExpire(row)
                            }">
                                {{ getImageStatusText(row) }}
                            </span>
                            <span v-if="row.is_image_three_to_four === 3 && !isImageExpire(row)" class="status-tag tag4"
                                @click="handleViewWhiteImg(row)">
                                查看效果
                            </span>
                            <!-- <span v-if="row.is_image_three_to_four === 3 && !isImageExpire(row)" class="status-tag tag4"
                                @click="handleViewWhiteImg(row)">
                                查看图片
                            </span> -->
                            <!-- 仅已生成且未过期显示查看按钮 -->
                            <!-- <el-button v-if="row.is_image_three_to_four === 3 && !isImageExpire(row)" size="mini"
                                type="primary" @click="handleViewWhiteImg(row)" style="margin-left:8px">
                                查看图片
                            </el-button> -->
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" prop="created_at" align="center" min-width="100" max-width="180">
                    <template #default="{ row }">
                        <el-button type="primary" size="mini" @click="handleEdit(row)">编辑商品</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit"
                @pagination="getDataList" layout="total, sizes, prev, pager, next, jumper" v-if="page_data.total > 0" />
        </div>
        <!-- 分组表单弹窗 -->
        <el-dialog title="生成3/4图片" :visible.sync="aiFormShow" width="600px">
            <el-form label-width="180px" :model="aiForm">
                <el-form-item label="选择商品分组">
                    <el-select v-model="aiForm.group_ids" filterable clearable multiple collapse-tags placeholder="全部"
                        @change="changeGroupIds">
                        <el-option v-for="group in groupList" :key="group.id" :label="group.name"
                            :value="group.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择商品子分组">
                    <el-select v-model="aiForm.child_group_ids" filterable clearable multiple collapse-tags
                        placeholder="全部">
                        <el-option v-for="group in child_groupList" :key="group.id" :label="group.name"
                            :value="group.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="SKU替换状态：">
                    <el-select v-model="aiForm.sku_status" clearable placeholder="全部">
                        <el-option v-for="item in skuWays" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="生成模型：">
                    <el-select v-model="aiForm.seg_type" placeholder="全部">
                        <el-option v-for="item in segWays" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="aiForm.seg_type == 2">
                    <template #label>
                        类目：
                        <el-tooltip content="根据选择的分组勾选相应的服饰类目" placement="top">
                            <i class="el-icon-question" style="color:#909399;margin-left:4px;cursor:pointer;"></i>
                        </el-tooltip>
                    </template>
                    <el-checkbox-group v-model="aiForm.clothing_type">
                        <el-checkbox v-for="item in clothingTypeOptions" :key="item.value" :label="item.value">
                            {{ item.label }}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item> -->
                <!-- <el-form-item label="生成图片类型：" required>
                    <el-select v-model="aiForm.target_types" filterable clearable multiple collapse-tags
                        placeholder="全部">
                        <el-option v-for="item in generateWays" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item> -->
                <!-- <el-form-item label="3：4图片生成数量：" required>
                    <el-input-number v-model="aiForm.three_to_four_count" :min="1" :max="5"
                        label="3：4图片生成数量："></el-input-number>
                </el-form-item> -->
                <el-form-item label="需要生成图片商品：" required>
                    <el-select v-model="aiForm.data_method" placeholder="全部">
                        <el-option v-for="item in checkWays" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <!-- <el-form-item label="AI提示词：" v-if="ismanager" required>
                    <el-select v-model="aiForm.ai_method" placeholder="全部">
                        <el-option v-for="item in aiWays" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item> -->

            </el-form>
            <template #footer>
                <span style="color: red; text-align: center;">选择商品不要超过1万,使用过程会消耗算力。 </span>
                <el-button @click="aiFormShow = false">取消</el-button>
                <el-button type="primary" @click="submitForm" :loading="submitFormLoading">确定</el-button>
            </template>
        </el-dialog>
        <!-- 在最外层 div 内添加 -->
        <el-image ref="globalImg" style="display: none;" :src="imageUrl" :preview-src-list="[imageUrl]"></el-image>
        <!-- 弹窗组件，传递API、全局提示、同步变量 -->
        <EditDialog :visible.sync="cloudEditShow" :cloud-edit-mode="cloudEditMode" :cloud-edit-list="cloudEditList"
            :cloud-edit-source-list="cloudEditSourceList" />
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

import Pagination from "@/components/pagination/pagination.vue";
import EditDialog from "../edit/editDialog.vue";

export default {
    props: {
        groupList: {
            type: Array,
            default: []
        },
    },
    components: {
        Pagination,
        EditDialog,
    },
    computed: {
        ...mapState({
            users: (state) => state.login.userinfo
        }),
    },
    data() {
        return {
            isManager: false,
            activeTab: 'task',
            aiFormShow: false,
            submitFormLoading: false,
            aiUpdateShow: false,
            aiUpdateLoading: false,
            loading: false,
            tableData: [],
            page_data: {
                limit: 10,
                page: 1,
                total: 0,
            },
            searchParams: {
                status: 1,
                is_image_three_to_four: '',
                sku_status: '',
                group_id: [],
                child_group_id: [],
            },
            aiUpdateForm: {
                id: '',
                old_word: '',
                new_word: '',
                before_word: '',
                after_word: '',
            },
            selectData: [],
            aiForm: { group_ids: [], child_group_ids: [], handler_types: 2, data_method: 1, ai_method: 1, sku_status: '', three_to_four_count: 5, seg_type: 1, clothing_type: [] },
            checkWays: [{ label: '未生成和已过期3:4', value: 2 }, { label: '全部商品', value: 1 }],
            skuWays: [{ label: '未替换', value: 1 }, { label: '已替换', value: 2 }, { label: '找不到', value: 3 }],
            segWays: [{ label: '商品生成', value: 1 }, { label: '服饰生成', value: 2 }],
            imageWays: [{ label: '未生成', value: 1 }, { label: '生成中', value: 2 }, { label: '已生成', value: 3 }, { label: '已过期', value: 4 }],
            generateWays: [{ label: '白底图', value: 1 }, { label: '3：4图片', value: 2 }, { label: '视频', value: 3 }],
            aiWays: [{ label: '正式AI提示词', value: 1 }, { label: '测试AI提示词', value: 2 }],
            status_list: [{ label: '待处理', value: 1 }, { label: '处理中', value: 2 }, { label: '处理完成', value: 3 }, { label: '已取消', value: 4 }, { label: '异常', value: 9 }],
            clothingTypeOptions: [
                { label: '上衣', value: 'tops' },
                { label: '外套', value: 'coat' },
                { label: '裙装', value: 'skirt' },
                { label: '裤装', value: 'pants' },
                { label: '包类', value: 'bag' },
                { label: '鞋子', value: 'shoes' },
                { label: '帽子', value: 'hat' }
            ],
            child_groupList: [],
            imageUrl: '', // 当前查看的图片URL
            cloudEditShow: false,
            cloudEditMode: 'single',
            cloudEditList: [],
            cloudEditSourceList: [],
        }
    },
    created() {
        this.ismanager = (this.users.mer_user_id === '1' || this.users.mer_user_id === '666')
        // this.$emit('update:is-manager', this.ismanager)
    },
    methods: {
        ...mapActions({
            opGetAIImgGenerateList: 'ucenter/opGetAIImgGenerateList',
            opPostAIImgGenerate: 'ucenter/opPostAIImgGenerate',
            getCloudProductList: 'ucenter/getCloudProductList',
            opGetAIImgWhiteImg: 'ucenter/opGetAIImgWhiteImg',
        }),
        initData() {
            this.refresh()
        },
        checkSelectable(row) {
            if (row.merchant_id === 0) {
                return this.ismanager === true;
            }
            return true;
        },
        getDataList() {
            this.tableData = []
            this.loading = true
            let param = { page_size: this.page_data.limit, page: this.page_data.page, ...this.searchParams }
            this.getCloudProductList({
                data: param,
                success: (res) => {
                    this.loading = false
                    if (res.code == 200) {
                        this.tableData = res.data.list
                        this.page_data.total = res.data.total
                    } else {
                        this.$message.error(res.message)
                    }

                }
            })
        },
        handleSearch() {
            this.page_data.page = 1
            this.getDataList()
        },
        refresh() {
            this.tableData = []
            this.page_data.page = 1
            this.page_data.total = 0
            this.child_groupList = []
            this.searchParams = {
                status: 1,
                is_image_three_to_four: '',
                sku_status: '',
                group_id: [],
                child_group_id: [],
            }
            this.getDataList()
        },

        submitForm() {
            this.submitFormLoading = true
            this.opPostAIImgGenerate({
                data: this.aiForm,
                success: (res) => {
                    this.submitFormLoading = false
                    if (res.code == 200) {
                        this.aiFormShow = false
                        this.$message.success(res.message)
                        this.getDataList()
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        handleCheck() {
            this.child_groupList = []
            this.aiFormShow = true
            this.aiForm.group_ids = []
            this.aiForm.child_group_ids = []
            this.aiForm.data_method = 1
            this.aiForm.ai_method = 1
            this.aiForm.handler_types = 2
            this.aiForm.seg_type = 1
            this.aiForm.clothing_type = []
            this.sku_status = ''
        },
        getGroupNameText(groupId, child_group_ids, flag = 0) {
            if (!groupId && flag === 0) return '全部'
            let ids = []
            if (typeof groupId === 'string') {
                try {
                    ids = JSON.parse(groupId)
                } catch (e) {
                    ids = groupId.split(',').map(item => item.trim())
                }
            } else {
                ids = Array.isArray(groupId) ? groupId : [groupId]
            }

            // 统一处理 child_group_ids 为数组
            let childIds = []
            if (typeof child_group_ids === 'string') {
                try {
                    childIds = JSON.parse(child_group_ids)
                } catch (e) {
                    childIds = child_group_ids.split(',').map(item => item.trim())
                }
            } else {
                childIds = Array.isArray(child_group_ids) ? child_group_ids : (child_group_ids ? [child_group_ids] : [])
            }

            return ids.filter(id => id) // 去掉空ID
                .map(id => this.groupList.find(item => item.id === id)) // 用ID匹配数组
                .filter(Boolean) // 过滤找不到的
                .map(item => {
                    let name = item.name
                    // 判断 item.child_groups 是否有值，并筛选出 id 存在于 child_group_ids 中的子分组
                    if (item.child_groups && item.child_groups.length > 0 && childIds.length > 0) {
                        const matchedChildNames = item.child_groups
                            .filter(child => childIds.includes(child.id))
                            .map(child => child.name)
                        // 如果有匹配的子分组，则用括号拼接展示
                        if (matchedChildNames.length > 0) {
                            name += `（${matchedChildNames.join('、')}）`
                        }
                    }
                    return name
                })
                .join('、')
        },
        changeGroupId(val) {
            this.$set(this.searchParams, 'child_group_ids', '')
            this.child_groupList = this.groupList.filter(i => val === i.id).map(i => i.child_groups || []).flat()
        },
        changeGroupIds(val) {
            this.$set(this.aiForm, 'child_group_ids', '')
            this.child_groupList = this.groupList.filter(i => val.includes(i.id)).map(i => i.child_groups || []).flat()
        },
        formatGroupName(row) {
            let group_id = row.group_id
            let group_name = this.groupList.find(i => i.id === group_id)?.name || '-'
            let child_group_id = row.child_group_id || '-'
            const target = this.groupList.find(i => i.id === group_id)?.child_groups?.find(i => i.id === child_group_id)
            const child_group_name = target?.name || null
            if (child_group_name) {
                group_name += '\n' + child_group_name
            }
            return group_name;
        },
        // 获取状态文字
        getImageStatusText(row) {
            const val = row.is_image_three_to_four;
            if (val === 1) return '未生成';
            if (val === 2) return '生成中';
            if (val === 3) {
                // 判断是否过期：生成时间 +90天 < 当前时间
                if (this.isImageExpire(row)) return '已过期';
                return '已生成';
            }
            return '未知';
        },

        // 判断白底图是否过期（image_three_to_four_at + 90天）
        isImageExpire(row) {
            if (!row.image_three_to_four_at) return true;
            const createTime = new Date(row.image_three_to_four_at);
            // 时间戳 + 90天毫秒数
            const expireTime = createTime.getTime() + 90 * 24 * 60 * 60 * 1000;
            const now = Date.now();
            return expireTime < now;
        },
        // 点击查看图片 请求接口
        handleViewWhiteImg(row) {
            try {
                this.opGetAIImgWhiteImg({
                    data: { 'product_id': row.product_id, 'type': 2 },
                    success: (res) => {
                        if (res.code == 200) {
                            // 设置图片URL并显示预览
                            if(res.data && res.data.length > 0 && res.data[0]) {
                                this.imageUrl = res.data[0];
                                this.imageUrlList = res.data;
                                this.$nextTick(() => {
                                    const img = this.$refs.globalImg
                                    if (img && img.clickHandler) {
                                        img.clickHandler()
                                    }
                                })
                            } else {
                                this.$message.error('未查询到图片')
                            }
                        } else {
                            this.$message.error(res.message)
                        }
                    }
                })
            } catch (err) {
                this.$message.error('图片加载失败');
            }
        },
        // 打开单条编辑
        handleEdit(row) {
            this.cloudEditMode = 'single'
            this.cloudEditList = [row]
            this.cloudEditShow = true
        },
        // 打开批量编辑
        handleCloudBatchEdit() {
            this.cloudEditMode = 'batch'
            this.cloudEditList = [...this.selectData]
            this.cloudEditShow = true
        },
        // 关闭弹窗重置数据
        handleCloudEditClose() {
            this.cloudEditDirty = false
            this.cloudEditMode = 'single'
            this.cloudEditList = []
            this.cloudEditShow = false
        },
    }
}
</script>


<style scoped>
.tab-box {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
}

.w_120 {
    width: 150px;
}

.w_220 {
    width: 220px;
}

.goods_wrap {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    width: 100% !important;
    box-sizing: border-box !important;
    /* align-items: center; */
}

/* 图片固定大小，不缩放变形 */
.img_box {
    width: 60px !important;
    height: 60px !important;
    flex-shrink: 0 !important;
}

.coverimg {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    border-radius: 4px !important;
}

/* 内容区域自动适配 */
.con_box {
    flex: 1 !important;
    min-width: 0 !important;
    width: 100% !important;
}

/* 每行信息样式 */
.info-item {
    display: flex !important;
    align-items: center !important;
    font-size: 12px !important;
    margin: 0 0 3px 0 !important;
    line-height: 1.3 !important;
    width: 100% !important;
    white-space: normal !important;
    word-wrap: break-word !important;
}

/* 标签固定宽度，统一对齐 */
.label {
    min-width: 44px !important;
    flex-shrink: 0 !important;
    color: #666 !important;
    margin-right: 4px !important;
    font-size: 12px !important;
}

/* 标题文字自动换行，不撑破布局 */
.color {
    flex: 1 !important;
    word-break: break-all !important;
    white-space: normal !important;
}

/* ========== 修改输入框：全屏幕自动适配 ========== */
.edit-row {
    display: flex !important;
    align-items: center !important;
    width: 100% !important;
}

.edit-row .el-input {
    flex: 1 !important;
    max-width: 450px !important;
    min-width: 160px !important;
    width: auto !important;
}

.edit-row .el-button {
    flex-shrink: 0 !important;
    margin-left: 6px !important;
}

/* ========== 表格核心：允许内容自动换行 + 不隐藏 ========== */
.el-table .cell {
    white-space: normal !important;
    overflow: visible !important;
    height: auto !important;
    padding: 6px 0 !important;
}

/* 每行信息：自己占一行，但内容不换行 */
.info-item {
    font-size: 13px;
    color: #333;
    margin: 0 0 4px 0;
    line-height: 1.4;

    /* 关键：本行内部不换行 */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 标签灰色 */
.label {
    color: #666;
    margin-right: 4px;
}

/* 内容蓝色 */
.color {
    font-size: 12px;
    color: #0096ff;
}

.source-tag {
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 12px;
    color: #fff;
}

.white-bg-status-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
}

.status-tag {
    margin-left: 1.5px;
    padding: 2px 8px;
    border-radius: 3px;
    font-size: 12px;
    color: #fff;
}

.tag1 {
    background: #409eff;
}

.tag2 {
    background: #67c23a;
}

.tag3 {
    background: #e6a23c;
}

.tagExpire {
    background: #3e3343;
}

.tag4 {
    background: #f56c6c;
}

.group-name-cell {
    white-space: pre-line;
}

.group-tip {
    white-space: pre-line !important;
}

/* 小屏幕自动适配：搜索表单缩小 + 自动换行 */
@media (max-width: 1445px) {
    .el-form--inline .el-form-item {
        margin-right: 8px !important;
        /* 缩小间距 */
    }

    .el-form--inline .el-form-item__label {
        padding: 0 6px !important;
        /* 标签间距缩小 */
        font-size: 12px !important;
        /* 标签文字变小 */
    }

    .el-form--inline .el-input,
    .el-form--inline .el-select {
        width: 130px !important;
        /* 输入框/下拉框变窄 */
    }

    .el-form--inline .el-button {
        padding: 6px 10px !important;
        /* 按钮变小 */
        font-size: 15px !important;
    }

    .img_box {
        width: 80px !important;
        height: 80px !important;
        flex-shrink: 0 !important;
    }

    .el-table,
    .el-table__cell,
    .info-item,
    .label,
    .color {
        font-size: 12px !important;
    }

    .no-padding-input>>>.el-input__inner {
        /* padding: 0 !important; */
        padding-left: 5px !important;
    }
}

.el-checkbox-group .el-checkbox {
    margin-right: 16px;
    margin-top: 6px;
}
</style>
